export default "__VITE_ASSET__BYOYQbgv__"